/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Who_1Inputs */

const en_mk_abt_who_1 = /** @type {(inputs: Mk_Abt_Who_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng is built by the same small team that builds Bystep. We share its stack, its design tokens and its release gates, and we run the product’s own development inside the product.`)
};

const id_mk_abt_who_1 = /** @type {(inputs: Mk_Abt_Who_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng dibangun oleh tim kecil yang sama dengan yang membangun Bystep. Kami memakai stack, token desain, dan gerbang rilis yang sama, dan kami memakai produknya sendiri untuk mengelola pembangunannya.`)
};

/**
* | output |
* | --- |
* | "KerjaBareng is built by the same small team that builds Bystep. We share its stack, its design tokens and its release gates, and we run the product’s own dev..." |
*
* @param {Mk_Abt_Who_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_who_1 = /** @type {((inputs?: Mk_Abt_Who_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Who_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_who_1(inputs)
	return en_mk_abt_who_1(inputs)
});